import { themes } from '../index.js';
import light from './light.css.js';

themes["light"] = light;
//# sourceMappingURL=index.js.map
